/*global angular $*/
import React from "react";
import moment from "moment";
import { connect } from "react-redux";
import classnames from "classnames";
import Slider from "react-slick";

import { goTo } from "../../tools";
import { authentication } from "../../app-database";
import { conectarFirebase } from "../../app-persistance";
import { movil } from "../../app-movil";
import { cargarPreguntas } from "../../miPerfil/datos.act";
import { nombreProductoGM, getNumPoliza } from "../../common/logica";
import { getClientInfo } from './pagoPorKilometro.act';

import VidaProducto from "../../home/productos/vidaProducto.cmpt";
import AutosProducto from "../../home/productos/autosProducto.cmpt";
import DaniosProducto from "../../home/productos/daniosProducto.cmpt";
import GastosProducto from "../../home/productos/gastosProducto.cmpt";

const verDetalleMovil = (bTouchId) => {
	if (!bTouchId) {
		goTo("movil/identidad");
		//window.location.href = "/#!/movil/identidad";
	} else {
		goTo("movil/detalle");
		//window.location.href = "/#!/movil/detalle";
	}
};

const mapState = (state) => {
	if (state.polizas.verDetalleMovil) {
		verDetalleMovil(state.polizas.touchId);
	}

	return {
		"loading": state.global.loading,
		"autos": state.polizas.autos,
		"gm": state.polizas.gm,
		"vida": state.polizas.vida,
		"danios": state.polizas.danios,
		"polizasCargadas": state.polizas.polizasCargadas,
		"nombre": state.global.nombre,
		"lastlogin": state.global.lastlogin,
		"cliente": state.global.clienteUnico,
		"ts": state.polizas.ts,
		"dotsActive": state.polizasMovil.dotsActive,
		"dotsDisplay": state.polizasMovil.dotsDisplay,
		"poliza": state.polizas.poliza,
		"callTs": state.polizas.callTs,
		"timeout": state.polizas.inactividad,
		"pagoPorKM": state.polizas.pagoPorKilometro
	};
};

const mapDispatch = (dispatch) => {
	return {
		setDetalle: (oPoliza) => {
			dispatch({ "type": "SET_DETALLE_POLIZA", "poliza": oPoliza });
		},
		cargarPreguntas : () => {
			dispatch(cargarPreguntas());
		},
		setDotsDisplay: (arreglo) => {
			dispatch({ "type": "SET_DOT_DISPLAY", "arreglo": arreglo });
		},
		setDotsActive: (arreglo) => {
			dispatch({ "type": "SET_DOT_ACTIVE", "arreglo": arreglo });
		},
		limpiarDetalle: () => {
			dispatch({ "type": "LIMPIAR_DETALLE_POLIZA" });
		},
		setRamoPoliza: (sCveRamo) => {
			dispatch({ "type": "SET_POLIZA_RAMO", "cveRamo": sCveRamo });
		},
		setMostrarAtras: () => {
			dispatch({ "type": "SET_MOSTRAR_ATRAS" });
		},
		setPago: (oPoliza) => {
			dispatch({ "type": "SET_DETALLE_POLIZA", "poliza": oPoliza });
			dispatch({ "type": "SET_POLIZA_SELECCIONADA", "polizaSeleccionada": oPoliza.generales.numPoliza });
			dispatch({ "type": "SET_RAMO_ACTUAL", "ramoActual": oPoliza.generales.cveRamo });
		}
	};
};

class Polizas extends React.Component {

	pago = (item, event) => {
		event.stopPropagation();
		console.log(event.currentTarget);
		console.log(item);
		this.props.setPago(item);
		goTo("movil/detalle/" + item.generales.numPoliza);
	}
	
	state = {
		"loaded": false,
		"tabAutos": "active",
		"tabGm": "",
		"tabVida": "",
		"tabDaños": "",
		"bgImg": require("../../img/image_bg.jpg"),
		"cards": true,
		"ramo": "tabAutos",
		"activeRamo": "autos",
		"vistaIndex": 0,
		"modoVista": [
			require("../../img/icon-lista-normal.svg"),
			require("../../img/icon-cards-normal.svg"),
		],
		"showProducto": false,
		"bgClass": "movil-autos-bg",
		"showversion":0,
		"version": 0
	}

	loadPolizas = () => {
		let redux = angular.element(document.querySelector("ui-view")).scope().$parent.state.redux;
		redux.dispatch({ "type": "CVE_CLIENTE_UNICO", "uid": authentication.currentUser.uid });
		this.props.cargarPreguntas();
		return conectarFirebase(redux, true);
	}
	
	componentWillMount = () => {
		this.setState({ "version": $("#hdnVersion").val() });
		let _this = this;
		
		this.props.setMostrarAtras();
		
		if (this.props.poliza.generales.cveRamo != "") {
			this.clearTabs();
			switch (this.props.poliza.generales.cveRamo) {
			case "A":
				this.selectTab("tabAutos");
				break;
			case "G":
				this.selectTab("tabGm");
				break;
			case "V":
				this.selectTab("tabVida");
				break;
			case "D":
				this.selectTab("tabDaños");
				break;
			}
		}
		
		authentication.onAuthStateChanged(function(user) {
			if (user && user.isAnonymous == false) {
				_this.loadPolizas().then(n=>{
					_this.mostrarPantalla();
					_this.initialDots("autos");
				});
			}
		});
		
		console.log("NAVIGATOR ONLINE", navigator.onLine);
		if (!navigator.onLine && window.localStorage.getItem("polizas")) {
			console.log("CARGA POLIZAS DE LOCALSTORAGE");
			let redux = angular.element(document.querySelector("ui-view")).scope().$parent.state.redux;
			let response = JSON.parse(window.localStorage.getItem("polizas"));
			redux.dispatch({
				"type": "POLIZAS_LLENAR",
				"autos": response.autos ? response.autos : [],
				"gm": response.gm ? response.gm : [],
				"vida": response.vida ? response.vida : [],
				"danios": response.danios ? response.danios : [],
				"ts": response.ts
			});
			_this.mostrarPantalla();
		}
		
		if (this.props.ts > 0) {
			_this.mostrarPantalla();
			if (_this.props.poliza.generales.cveRamo == "A" || _this.props.poliza.generales.cveRamo == "") {
				_this.initialDots("autos");
			}
			if (_this.props.poliza.generales.cveRamo == "G") {
				_this.initialDots("gm");
			}
			if (_this.props.poliza.generales.cveRamo == "V") {
				_this.initialDots("vida");
			}
			if (_this.props.poliza.generales.cveRamo == "D") {
				_this.initialDots("danios");
			}
		}
	}

	initialDots = (ramo) => {
		/*Esta función es una versión hardcodeada de dots. Checa el ramo de autos,
		que es el default. Sólo se llama una vez, en el componentWillMount.
		Después de eso, la lógica de los puntos la maneja dots*/
		for (var i = 0; i < 3; i++) {
			$("#dot" + (i + 1)).addClass("hide");
		}
		let displays = [];
		// let actives = ["dot-active", "", ""];
		if (this.props[ramo].length == 0) {
			displays = ["hide", "hide", "hide"];
		} else if (this.props[ramo].length == 1) {
			displays = ["", "hide", "hide"];
		} else if (this.props[ramo].length == 2) {
			displays = ["", "", "hide"];
		} else {
			displays = ["", "", ""];
		}
		this.props.setDotsDisplay(displays);
		setTimeout(() => {
			for (var i = 0; i < 3; i++) {
				if(displays[i].length == 0) {
					$("#dot" + (i + 1)).removeClass("hide");
				}
			}
		}, 500);
	}
	
	clearTabs = () => {
		this.setState({
			"tabAutos": "",
			"tabGm": "",
			"tabVida": "",
			"tabDaños":""
		});
	}
	
	selectTab = (sTab) => {
		var _this = this;
		try { event.preventDefault(); } catch(e) { }
		if (this.state.cards && this.props[this.state.activeRamo].length != 0) {
			/*Esto resettea la posición del slider a 0 cuando cambias de ramo.
			Es importante no hacerlo cuando estás en modo lista o cuando no tienes pólizas en
			un ramo, porque entonces no tienes slider y el método no existe.
			*/
			try {
				this.refs.slider.slickGoTo(0);
			} catch(e) {
				
			}
			
			var bgClass;
		}
		var ramo;
		switch (sTab) {
		case "tabAutos":
			ramo = "autos";
			bgClass="movil-autos-bg";
			break;
		case "tabGm":
			ramo = "gm";
			bgClass="movil-gm-bg";
			break;
		case "tabVida":
			ramo = "vida";
			bgClass="movil-vida-bg";
			break;
		case "tabDaños":
			ramo = "danios";
			bgClass="movil-danios-bg";
			break;
		}
		this.clearTabs();
		let state = {
			"activeRamo": "",
			"ramo": "",
			"showProducto": false,
			"bgClass": bgClass,
		};
		state[sTab] = "active";
		state.activeRamo = ramo;
		state.ramo = sTab;
		this.setState(state, () => {
			_this.launchView();
		});
		this.initialDots(ramo);
	}
	
	createSlider = () => {
		let values = this.setInitialValues();
		setTimeout(() => {
			$(".bxslider").addClass("bx-viewport-slide");
		}, 500);
	}
	
	mostrarPantalla = () => {
		var _this = this;
		this.setState({ "loaded": true }, () => {
			_this.createSlider();
			var timeout = setInterval( () => {
				_this.slideCounter();
				clearInterval(timeout);
			}, 1500);
		});
	}
	
	toggleView = () => {
		var vistaIndex;
		if (this.state.vistaIndex == 0) {
			vistaIndex = 1;
		} else if (this.state.vistaIndex == 1) {
			vistaIndex = 0;
		}
		var _this = this;
		this.setState({
			"cards": !this.state.cards,
			"vistaIndex": vistaIndex,
		}, () => {
			_this.launchView();
		});
	}
	
	launchView = () => {
		if (this.state.cards) {
			this.createSlider();
			this.initialDots(this.state.activeRamo);
		} else {
			$("li.polizas-list-item").each(function(i){
				var t = $(this);
				setTimeout(function(){ t.addClass("polizas-list-item-visible"); }, (i+1) * 150);
			});
		}
		this.slideCounter();
	}
	
	verDetalle = (item) => {
		this.props.setDetalle(item);		
		if(item.generales && item.generales.pendientePago){
			this.props.setPago(item);			
		}		
		if (new Date() > new Date(this.props.callTs + this.props.timeout)) {
			movil("polizas.detalle", { "return": "huella" });
		} else {
			goTo("movil/detalle");
			//window.location.href = "/#!/movil/detalle";
		}
	}
	
	setInitialValues = () => {
		let sRamo = this.state.ramo;
		let polizas = [], ramo = "", sliderTop = 0;
		
		switch (sRamo) {
		case "tabAutos":
			polizas = this.props.autos;
			ramo = "Autos";
			break;
		case "tabGm":
			polizas = this.props.gm;
			ramo = "Gastos Médicos Mayores";
			break;
		case "tabVida":
			polizas = this.props.vida;
			ramo = "Vida";
			break;
		case "tabDaños":
			polizas = this.props.danios;
			ramo = "Daños";
			break;
		}
		if (polizas.length > 1) {
			sliderTop = (polizas.length - 1) * -22;
		}
		return {
			"polizas": polizas,
			"ramo": ramo,
			"sliderTop": sliderTop
		};
	}
	
	puntosClass = (currentSlide, nextSlide, ramo) => {
	  /*Esta función se encarga de la lógica de los puntos del slider.
	  La llama el método beforeChange del slider. Utilizamos props en lugar de state
	  porque hay un bug en el método del slider que conflictúa con setState.
	  */
		for (var i = 0; i < 3; i++) {
			$("#dot" + (i + 1)).removeClass("dot-active");
		}
		let tmp = [];
		switch(nextSlide) {
		case 0:
			tmp = ["dot-active", "", ""];
			break;
		case this.props[ramo].length:
			tmp = ["", "", "dot-active"];
			break;
		default:
			tmp = ["", "dot-active", ""];

		}
		this.props.setDotsActive(tmp);
		for (var i = 0; i < 3; i++) {
			if(tmp[i].length > 0) {
				$("#dot" + (i + 1)).addClass("dot-active");
			}
		}
	}
	
	toggleProducto = () => {
		// console.log("toggleProducto corriendo");
		this.setState({
			"showProducto": !this.state.showProducto
		});
	}
	
	goBack = () => {
		// console.log("goBack corriendo");
		this.setState({
			showProducto: false
		});
	}
	
	mostrarAgregarPoliza = () => {
		if (this.state.tabAutos == "active") {
			this.props.setRamoPoliza("A");
		}
		if (this.state.tabGm == "active") {
			this.props.setRamoPoliza("G");
		}
		if (this.state.tabVida == "active") {
			this.props.setRamoPoliza("V");
		}
		if (this.state.tabDaños == "active") {
			this.props.setRamoPoliza("D");
		}
		
		goTo("movil/polizas/agregar");
		//window.location.href = "/#!/movil/polizas/agregar";
	}
	
	slideCounter = () =>{
		var counter = this.props[this.state.activeRamo].length * 20;
		$(".counter").css({"marginTop":"-" + counter + "px"});
	}
	
	showVersion = () => {
		if (this.state.showversion == 5) {
			this.setState({ "showversion": 0 });
			alert($("#hdnVersion").val());
		} else {
			this.setState({ "showversion": (this.state.showversion + 1) });
		}
	}

	policyStartDateIsFuture = (date) => {

		let currentDate = moment().format('DD/MM/YYYY');		
		let fechaFutura = moment(date, 'DD/MM/YYYY').add(14, 'd').format('DD/MM/YYYY');

		return (moment(fechaFutura, 'DD/MM/YYYY').diff(moment(currentDate, 'DD/MM/YYYY'),'d') <= 14) ? false : true;
	}

	
	render() {
		// console.log(this.state);
		console.log(this.props);
		var view = classnames({
			"header-content": true,
			"clearfix": true,
			"vista": this.state.cards,
			"vista-lista": !this.state.cards
		});
		let _this = this;
		let totalPolizas = this.props.autos.length + this.props.gm.length + this.props.danios.length + this.props.vida.length;
		let vidaPolizas = this.props.vida.length;
		let daniosPolizas = this.props.danios.length;
		let gmPolizas = this.props.gm.length;
		let autosPolizas = this.props.autos.length;
		let iPolizas = 0;
		let polizas = [];
		let values = this.setInitialValues();
		// values.polizas.push(values.polizas[0]);
		// values.polizas[values.polizas.length - 1].agregar = true;
		let sliderSettings = {
			dots: false,
			infinite: false,
			speed: 300,
			controls: false,
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: "25px",
			beforeChange: (currentSlide, nextSlide) => {
				// console.log("currentSlide: ", currentSlide);
				// console.log("nextSlide: ", nextSlide);
				if (this.state.tabAutos == "active") {
					// console.log("autos");
					this.puntosClass(currentSlide, nextSlide, "autos");
				} else if (this.state.tabGm == "active") {
					// console.log("gm");
					this.puntosClass(currentSlide, nextSlide, "gm");
				} else if (this.state.tabDaños == "active") {
					// console.log("daños");
					this.puntosClass(currentSlide, nextSlide, "danios");
				} else if (this.state.tabVida == "active") {
					// console.log("vida");
					this.puntosClass(currentSlide, nextSlide, "vida");
				} else {
					// console.log("Muy raro");
				}
			}
		}

		return (
			<div className="polizas-mobile">
				<div>
					{ this.state.loaded &&
						<div className="movil-container">
							<div className="box-wrap">
								<div className="second-menu text-center">
									<ul className="clearfix">
										<li><a className={this.state.tabAutos} onClick={this.selectTab.bind(this, "tabAutos")}>Autos ({ autosPolizas })</a></li>
										<li><a className={this.state.tabGm} onClick={this.selectTab.bind(this, "tabGm")}>GMM ({ gmPolizas })</a></li>
										<li><a className={this.state.tabVida} onClick={this.selectTab.bind(this, "tabVida")}>Vida ({ vidaPolizas })</a></li>
										<li><a className={this.state.tabDaños} onClick={this.selectTab.bind(this, "tabDaños")}>Daños ({ daniosPolizas })</a></li>
									</ul>
								</div>

								{ values.polizas.length == 0 && !this.state.showProducto &&
									<div>
										<div className="card card-fix">
											<div className="sin-polizas-container">
												<div className="sin-polizas-wrap" style={{ "padding": "0px", "margin": "0px auto" }}>
													<img src={require("../../img/sin-polizas-icon.png")} />
													<span>Aún no tienes agregadas pólizas de este ramo.</span>
													<a onClick={this.mostrarAgregarPoliza} className="conoce-mas-btn-agregar">Agregar póliza <span className=" glyphicon glyphicon-menu-right"></span></a>
												</div>
											</div>
										</div>
										<br/>
										<div className="card card-fix">
											<div className="sin-polizas-container">
												<div>
													<p style={{ "textAlign": "center", "color": "" }}>Conoce todos los beneficios que te ofrecen los seguros de {values.ramo} GNP.</p>
													<br/>
													<a onClick={this.toggleProducto} className="conoce-mas-btn-agregar">Conoce más <span className=" glyphicon glyphicon-menu-right"></span></a>
												</div>
											</div>
										</div>
									</div>
								}
								{ values.polizas.length == 0 && this.state.showProducto &&
									<div>
										{ this.state.activeRamo == "autos" &&
											<AutosProducto showArrow={true} goBack={this.toggleProducto} />
										}
										{ this.state.activeRamo == "gm" &&
											<GastosProducto showArrow={true} goBack={this.toggleProducto} />
										}
										{ this.state.activeRamo == "vida" &&
											<VidaProducto showArrow={true} goBack={this.toggleProducto} />
										}
										{ this.state.activeRamo == "danios" &&
											<DaniosProducto showArrow={true} goBack={this.toggleProducto} />
										}
									</div>
								}

								{ values.polizas.length > 0 &&
									<div>
										<div className={((this.props.autos.length == 0 && this.state.tabAutos == "active") || (this.props.gm.length == 0 && this.state.tabGm == "active") || (this.props.vida.length == 0 && this.state.tabVida == "active") || (this.props.danios.length == 0 && this.state.tabDaños == "active") ) ? "movil-bg" : this.state.bgClass }></div>
										<div className={view}>
											<div className={ this.props[this.state.activeRamo].length == 0 ? "hide" : "movil-head" }>
												<h4 className="movil-h4">{ values.ramo }</h4>
												<img className="modo-vista-icon" onClick={this.toggleView} src={this.state.modoVista[this.state.vistaIndex]}/>
												<div className="polizas-number">
													<div className="counter-style">
														<div className="counter">
															<span>0</span>
																{this.props[this.state.activeRamo].map((item, i) =>
																	<span key={i}>{i + 1}</span>
																)}
														</div>
													</div>
													<h4>{ this.props[this.state.activeRamo].length == 1 ? "Póliza" : "Pólizas" }</h4>
												</div>
												<h6><small><b>Última sesión:</b> { this.props.lastlogin }</small></h6>
												<h6>&nbsp;</h6>
												{/*<h6><small>{this.state.version}</small></h6>
												<h6 onClick={this.showVersion}><small><b>Información actualizada al:</b> { this.props.lastlogin }</small></h6>*/}
											</div>
											<div className="pull-left">
												<a href=""></a>
											</div>
										</div>
										<div className="cards-wrap mobile-cards-wrap">
											<div className="">
												{ this.state.cards &&
													<div className="col-md-4 col-xs-12 no-pad">
														{ values.polizas.length > 0 &&
															<Slider ref="slider" className="bxslider" {...sliderSettings}>
																{ values.polizas.map((item, i) => 
																	<div data-index={i} key={i} onClick={this.verDetalle.bind(this, item)}>
																		<div className="card card-fix" style={{"height": "250px"}}>
																			<div className="header-card-mobile title-slider">
																				<div className="title-icon">
																					{ values.ramo == "Autos" &&
																						<h6 className="titulo-auto">{ ( item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") ? ("GRUPO: ") : ""}{item.vehiculo.descripcion}</h6>
																					}
																					{ values.ramo == "Autos" &&
																						<div className="placas-auto" style={{"top":"0"}}>
																							<p>{item.vehiculo.placas}</p>
																						</div>
																					}
																					{ values.ramo == "Gastos Médicos Mayores" &&
																						<h6>{ nombreProductoGM(item) }</h6>
																					}
																					{ values.ramo == "Vida" &&
																						<h6>{ ( item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") ? ("GRUPO: ") : ""}{ item.generales.productoComercial }</h6>
																					}
																					{ values.ramo == "Daños" &&
																						<h6>{ ( item.generales.cveClasificacionSeguro == "06" || item.generales.cveClasificacionSeguro == "05") ? ("GRUPO: ") : ""}{ item.generales.productoComercial } C.P. { item.generales.codigoPostal }</h6>
																					}
																				</div>
																			</div>
																			<div className="vigencia">
																				<p>Vigencia</p>
																				<p>
																					<span className="blue-circle"></span>Desde { moment(item.generales.fchVigenciaInicial, "DD/MM/YYYY").format("LL") }
																				</p>
																				<p>
																					<span className="orange-point"></span>Hasta el { moment(item.generales.fchVigenciaFinal, "DD/MM/YYYY").format("LL") }
																				</p>
																			</div>
																			<div className="clearfix no-poliza-movil">
																				{
																					this.props.pagoPorKM && ((typeof this.props.pagoPorKM[item.generales.numPoliza] === 'undefined' || 
																					! ( this.props.pagoPorKM[item.generales.numPoliza].candidate ) || 
																					(!this.props.pagoPorKM[item.generales.numPoliza].enabled && !this.props.pagoPorKM[item.generales.numPoliza].isStartKmCaptured )
																					) ? false : true)
																					&& (item.generales.claveRol == 'TOM' || item.generales.claveRol == 'COH')
																					&& !this.policyStartDateIsFuture(item.generales.fchVigenciaInicial) ? 
																						<div className="pull-left">
																							<div className="col-xs-10" style={{paddingLeft:"0px", paddingRight:"0px"}} >
																								<p>
																									<img src={require("../../img/icon-poliza.png")} alt="" /><b>No. Póliza: { getNumPoliza(item) }</b>
																								</p>
																							</div>
																							<div className="col-xs-2" style={{paddingLeft:"0px", paddingRight:"0px"}}>
																								<img className="img-responsive center-block" style={{'marginTop': '-13px', 'marginLeft': '25%','marginBottom':'0px'}} src={require('../../img/smart-trip.png')} />
																							</div>
																						</div> :
																						<div className="pull-left">
																							<div className="col-xs-12" style={{paddingLeft:"0px", paddingRight:"0px"}}>
																								<p>
																									<img src={require("../../img/icon-poliza.png")} alt="" /><b>No. Póliza: { getNumPoliza(item) }</b>
																								</p>
																							</div>
																						</div>
																				}
																				{/* <div className="pull-left">
																					<div className="col-xs-12" style={{paddingLeft:"0px", paddingRight:"0px"}}>																					
																						{  	this.props.polizasCargadas &&
																							item.generales.detalle != "capitaliza" && 
																							item.generales.detalle != "inversion" &&
																							item.generales.estatus != "" &&
																							!(item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
																							!(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
																							!(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS INCREMENTO
																							<p className="orange-text pago-pendiente">{ item.generales.estatus }</p>
																						}
																						{	this.props.polizasCargadas && 
																							(item.generales.detalle == "capitaliza" || item.generales.detalle == "inversion") && 
																							item.generales.estatus != "" &&
																							!(item.generales.cveProdComercial == "00012" && item.generales.cveProdTecnico == "A2400FLOT") && // AUTO MAS
																							!(item.generales.cveProdComercial == "00002" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS
																							!(item.generales.cveProdComercial == "00003" && item.generales.cveProdTecnico == "V1011PFLVM") && // VIDA MAS INCREMENTO
																							<p onClick={this.pago.bind(this, item)} className="pago-pendiente capitaliza">{ item.generales.estatus }</p>
																						}
																					</div>
																				</div> */}

																				{
																					this.props.pagoPorKM[item.generales.numPoliza] && this.props.pagoPorKM[item.generales.numPoliza].isStartKmCaptured
																					&& this.props.pagoPorKM[item.generales.numPoliza].enableFinalCapture && !this.props.pagoPorKM[item.generales.numPoliza].isEndKmCaptured
																					?
																					<div className="vigencia">
																						<p>
																							Registra tu kilometraje final antes del: {this.props.pagoPorKM[item.generales.numPoliza].terminoPoliza? this.props.pagoPorKM[item.generales.numPoliza].terminoPoliza: ''}
																						</p>
																					</div>
																					:
																					this.props.pagoPorKM[item.generales.numPoliza] && this.props.pagoPorKM[item.generales.numPoliza].isStartKmCaptured 
																					&& !this.props.pagoPorKM[item.generales.numPoliza].enableFinalCapture && !this.props.pagoPorKM[item.generales.numPoliza].isEndKmCaptured
																					&& 
																					<div className="vigencia">
																						<p>
																							Registra tu kilometraje final a partir del: {this.props.pagoPorKM[item.generales.numPoliza].inicioRegFinal? this.props.pagoPorKM[item.generales.numPoliza].inicioRegFinal: ''}
																						</p>
																					</div>
																				}

																			</div>
																		</div>
																	</div>
																)}
																{
																	<div data-index={values.polizas.length} onClick={this.mostrarAgregarPoliza}>
																		<div className="card card-fix" style={{ "height": "250px" }}>
																			<div className="header-card-mobile title-slider" style={{ "textAlign": "center" }}>
																				<div className="title-icon">
																					<h6 className="titulo-auto">Agregar póliza</h6>
																				</div>
																			</div>
																			<div className="clearfix no-poliza-movil">
																				<div style={{ "textAlign": "center", "marginTop": "25px" }}>
																					<img src={require("../../img/icon-add.svg")} alt="" style={{ "height": "64px"}}/>
																				</div>
																			</div>
																		</div>
																	</div>
																}
															</Slider>
														}
														<div className="dots-wrap">
															<div className={this.props.dotsDisplay[0] + " " + this.props.dotsActive[0] + " dot hide"} id="dot1"></div>
															<div className={this.props.dotsDisplay[1] + " " + this.props.dotsActive[1] + " dot hide"} id="dot2"></div>
															<div className={this.props.dotsDisplay[2] + " " + this.props.dotsActive[2] + " dot hide"} id="dot3"></div>
														</div>
													</div>
												}
												{ !this.state.cards &&
													<div>
														{ values.polizas.length > 0 &&
															<ul className="row polizas-list-mobile">
																{ values.polizas.map((item, i) =>
																	<li className="polizas-list-item" key={i} onClick={this.verDetalle.bind(this, item)}>
																		<div className="clearfix">
																			{ values.ramo == "Autos" &&
																				<div>
																					<h6 className="pull-left">{ item.vehiculo.descripcion } { item.vehiculo.modelo }</h6>
																					<h6 className="pull-right">{ item.vehiculo.placas }</h6>
																				</div>
																			}
																			{ values.ramo == "Gastos Médicos Mayores" &&
																				<div>
																					<h6 className="pull-left">{ nombreProductoGM(item) } <br /></h6>
																				</div>
																			}
																			{ values.ramo == "Vida" &&
																				<div>
																					<h6 className="pull-left">{ item.generales.productoComercial }</h6>
																				</div>
																			}
																			{ values.ramo == "Daños" &&
																				<div>
																					<h6 className="pull-left">{ item.generales.productoComercial }</h6>
																				</div>
																			}
																		</div>
																		<div className="clearfix no-poliza-movil">
																			<div className="pull-left">
																				<p><img src={require("../../img/icon-poliza.png")} alt="" />No. Póliza: { getNumPoliza(item) }</p>
																			</div>
																			<div className="pull-right">
																				{/*<p className="orange-text">{ item.generales.estatus }</p>*/}
																			</div>
																		</div>
																	</li>
																)}
																<li className="polizas-list-item" key={values.polizas.length} onClick={this.mostrarAgregarPoliza}>
																	<div className="clearfix">
																		<div>
																			<h6 className="pull-left" style={{ "paddingTop": "12px"}}>Agregar póliza</h6>
																			<h6 className="pull-right"><img src={require("../../img/icon-add.svg")} alt="" style={{ "height": "40px"}}/></h6>
																		</div>
																	</div>
																</li>
															</ul>
														}
													</div>
												}
											</div>
										</div>
									</div>
								}
							</div>
						</div>
					}
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Polizas);


// WEBPACK FOOTER //
// ./src/movil/polizas/polizas.cmpt.js